/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { IDBGroup } from "@netfront/gelada-identity-library";
import { FormFieldProps } from "@netfront/ui-library";
import { IUpdatedCustomField } from "types";


const getGroupDefaultValues = ({ group, customFields = [] }: { customFields?: IUpdatedCustomField[]; group?: IDBGroup; }): FormFieldProps => {

  const { 
    groupTypeId,
    name,
    phoneNumber,
    website,
    status,
    address,
    smartCodes = []
  } = group ?? {};
  const { city, country, line1, line2, line3, postcode, state } = address ?? {};

  const customFieldsObject = customFields.reduce((acc, item) => {
    const { customFieldId, text } = item;
    
    acc[`customField${customFieldId}`] = text;
    
    return acc;
  }, {} as FormFieldProps);

  return {
    name: name || '',
    groupTypeId: groupTypeId || '',
    phoneNumber: phoneNumber || '',
    website: website || '',
    city: city || '',
    country: country || '',
    line1: line1 || '',
    line2: line2 || '',
    line3: line3 || '',
    postcode: postcode || '',
    state: state || '',
    smartCodes: smartCodes,
    isActive: status === 'ACTIVE',
    ...customFieldsObject,
  };
};

const getCustomFieldResponses = ({ customFields = [], item }: { customFields?: IUpdatedCustomField[]; item: FormFieldProps }) => {

  const formattedResponses = customFields.map(({ customFieldId }) => {
    return {
      customFieldId,
      value: String(item[`customField${customFieldId}`] ?? ''),
    };
  });

  return formattedResponses;
};


export {getGroupDefaultValues, getCustomFieldResponses };
